exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading .logo{position:fixed;right:0;bottom:0;margin:20px;width:100px}", ""]);

// exports
